class Timer {
  constructor() {
    this.timer = null;
    this.isClearedTimer = false;
  }

  debounce(func, time) {
    if (this.isClearedTimer) {
      return;
    }

    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(func, time);
  }

  clear() {
    this.isClearedTimer = true;
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}

export default Timer;
